import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.33333 14.6666C9.33333 14.6666 9.8995 14.5857 12.2426 12.2426C14.5858 9.89941 14.5858 6.10042 12.2426 3.75728C11.4125 2.9271 10.3995 2.39105 9.33333 2.14914M9.33333 14.6666H13.3333M9.33333 14.6666L9.33333 10.6666M6.66667 1.33338C6.66667 1.33338 6.1005 1.41426 3.75736 3.75741C1.41421 6.10055 1.41421 9.89954 3.75736 12.2427C4.58754 13.0729 5.60048 13.6089 6.66667 13.8508M6.66667 1.33338L2.66667 1.33325M6.66667 1.33338L6.66667 5.33325",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRefresh;
